module.exports = __webpack_public_path__ + "static/media/lincoln-logo.548bcfad.svg";